import { NgxPaginationModule } from 'ngx-pagination';
import { NotificationsComponent } from './shared/notifications/notifications.component';
import { SearchPipe } from './shared/pipes/search.pipe';
import { ProfileComponent } from './profile/profile.component';
import { HttpInterceptorProvider } from './config/authinterceptor';
import { AppStateProvider } from './services/app-state.provider';
import { ToastMessage } from './shared/toast/toast.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BookMeetingRoomComponent } from './meeting-room-CLA/book-meeting-room/book-meeting-room.component';
import { BookingConfirmationComponent } from './meeting-room-CLA/booking-confirmation/booking-confirmation.component';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { EditMeetingRoomComponent } from './meeting-room-CLA/edit-meeting-room/edit-meeting-room.component';
import { OverviewComponent } from './overview/overview.component';
import { MembersCLAModule } from './members-CLA/members-cla.module';
import { MembersRoutingModule } from './members-CLA/members-routing.module';
import { LoginComponent } from './login/login.component';
import { CompaniesCLAModule } from './companies/companies-cla.module';
import { CompaniesRoutingModule } from './companies/companies-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportsComponent } from './reports/reports.component';
import { ContactComponent } from './contact/contact.component';
import { DatePipe } from '@angular/common';
// import { AuthenticationGuard, MsAdalAngular6Module } from 'microsoft-adal-angular6'; // Deprecated - using MSAL v3 instead
import { environment } from 'src/environments/environment';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { CreditsRoutingModule } from './credit-score/credit-score-routing.module';
import { CreditsCLAModule } from './credit-score/credit-score-cla.module';
import { EmptyStateComponent } from './shared/empty-state/empty-state/empty-state.component';
import { FaqModule } from './FAQs/faq.model';
import { CompanyModule } from './company-module/company.model';
import { ApprovalModule } from './bulk-invite-approval/approval.module';
import { OverviewModuleComponent } from './overview-module/overview-module.component';
import { ParkiteReportComponent } from './parkite-report/parkite-report/parkite-report.component';
import { CompanyViewComponent } from './company-module/company-view/company-view.component';
import { AutosizeModule } from 'ngx-autosize';
import { ConfirmDailogComponent } from './company-module/shared/confirm-dailog/confirm-dailog.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
// import { EventsCLAModule } from './events/events-cla.module';
// import { EventsRoutingModule } from './events/events-routing.module';
import { ProfileVerificationComponent } from './profile-verification/profile-verification/profile-verification.component';
import { ProfileParkiteComponent } from './profile-parkite/profile-parkite.component';
import { GstChargesComponent } from './gst-charges/gst-charges.component';

import { AngularSvgIconModule } from 'angular-svg-icon';

// import { AddNewPlantTreesComponent } from './landscaping-and-vegetation/add-new-plant-trees/add-new-plant-trees.component';
// import { PlantDetailsComponent } from './landscaping-and-vegetation/plant-details/plant-details.component';
// import { ListOfPlantsTreesComponent } from './landscaping-and-vegetation/list-of-plants-trees/list-of-plants-trees.component';
// import { PrintQrCodeComponent } from './landscaping-and-vegetation/print-qr-code/print-qr-code.component';
import { DownloadQrComponent } from './modal/download-qr/download-qr.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { RemoveModalComponent } from './modal/remove-modal/remove-modal.component';

import { LandscapingModule } from './landscaping-and-vegetation/landscaping.module';
import { CouponsectionModule } from './coupons/couponsection.module';
import { SurveypollsModule } from './survey-polls/surveypolls.module';
import { CustomerserviceModule } from './customer-service-group/customerservice.module';
import { FoodcourtModule } from './food-court/foodcourt.module';

import { WorkpermitModule } from './work-entry-permit/workpermit.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GeneratePdfComponent } from './_Shared/_Components/_Generic/generate-pdf/generate-pdf.component';

import { RemovemodalcouponComponent } from './modal/remove-modal-coupon/remove-modal-coupon.component';
import { AssigncouponComponent } from './modal/assign-coupon/assign-coupon.component';
import { RemovemodalcouponsurveyComponent } from './modal/remove-modal-coupon-survey/remove-modal-coupon-survey.component';
import { RemoveModalCustomerserviceUserComponent } from './modal/remove-modal-customerservice-user/remove-modal-customerservice-user.component';
import { RemoveModalGroupUserComponent } from './modal/remove-modal-group-user/remove-modal-group-user.component';

import { ChangeUserGroupComponent } from './modal/change-user-group/change-user-group.component';
import { ChangeUserGroupSingleComponent } from './modal/change-user-group-single/change-user-group-single.component';
import { SendSurveyReminderComponent } from './modal/send-survey-reminder/send-survey-reminder.component';
import { SurveyReminderSuccessComponent } from './modal/survey-reminder-success/survey-reminder-success.component';

import { RemovemodalvendorComponent } from './modal/remove-modal-vendor/remove-modal-vendor.component';
import { RemovemodalmenuComponent } from './modal/remove-modal-menu/remove-modal-menu.component';
import { ReviewremoveflagComponent } from './modal/review-remove-flag/review-remove-flag.component';
import { HidevendorreviewComponent } from './modal/hide-vendor-review/hide-vendor-review.component';
import { RemovemodalfoodcourtComponent } from './modal/remove-modal-food-court/remove-modal-food-court.component';

import { BookFacilityComponent } from './modal/book-facility/book-facility.component';
import { CancelFacilityBookingComponent } from './modal/cancel-facility-booking/cancel-facility-booking.component';

//import { CreditScoreCLAComponent } from './credit-score/credit-score-CLA/credit-score-cla.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ViewBlockedFacilityComponent } from './facility-booking/view-blocked-facility/view-blocked-facility.component';
import { AssignmembercardModule } from './assign-membercard/assignmembercard.module';

import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { AdalAuthComponent } from './adal-auth/adal-auth.component';

import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { ActiveParkConfirmationComponent } from './modal/active-park-confirmation/active-park-confirmation.component';
// import { EmergencyInfoComponent } from './emergency-info/emergency-info.component';
import { EmergencyinfoModule } from './emergency-info/emergencyinfo.module';

import { RolepermissionModule } from './role-permission/rolepermission.module';
import { RemovemodaluserroleComponent } from './modal/remove-modal-user-role/remove-modal-user-role.component';
import { AssignmodaluserroleComponent } from './modal/assign-modal-user-role/assign-modal-user-role.component';

import { ActiveEventCategoryModalComponent } from './modal/active-event-category-modal/active-event-category-modal.component';
import { ActiveEventModalComponent } from './modal/active-event-modal/active-event-modal.component';
import { DeactiveEventCategoryModalComponent } from './modal/deactive-event-category-modal/deactive-event-category-modal.component';
import { ApproveRejectPerticipantModalComponent } from './modal/approve-reject-perticipant-modal/approve-reject-perticipant-modal.component';
import { MeetingroomModule } from './meeting-room/meetingroom.module';
import { BookNewMeetingRoomComponent } from './modal/book-new-meeting-room/book-new-meeting-room.component';
import { CancelMeetingroomBooking } from './modal/cancel-meetingroom-booking/cancel-meetingroom-booking.component';

import { SecurityPasswordResendComponent } from './modal/security-password-resend/security-password-resend.component';
import { ViewBookingCompanyRoomComponent } from './company-module/company-meeting-room/view-booking-company-room/view-booking-company-room.component';

import { ViewMeetingRoomBookingComponent } from './company-module/company-meeting-room/view-meeting-room-booking/view-meeting-room-booking.component';
import { MeetingroomCancelPortalComponent } from './modal/meetingroom-cancel-portal/meetingroom-cancel-portal.component';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId, // "9d5b27e3-e8ee-4d50-b0bd-6dd88f9a2456",
      // clientId: '3fba556e-5d4a-48e3-8e1a-fd57c12cb82e', // PPE testing environment
      authority: 'https://login.microsoftonline.com/' + environment.tenant,
      // authority: "https://login.microsoftonline.com/common",
      // authority: 'https://login.windows-ppe.net/common', // PPE testing environment
      redirectUri: environment.redirectUri,
      postLogoutRedirectUri: environment.postLogoutRedirectUri
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
      // storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  // protectedResourceMap.set('https://graph.microsoft-ppe.com/v1.0/me', ['user.read']); // PPE testing environment

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read']
    },
  };
}

@NgModule({
  declarations: [
    AppComponent,
    // BookMeetingRoomComponent,
    // BookingConfirmationComponent,
    // EditMeetingRoomComponent,
    OverviewComponent,
    // EmptyStateComponent,
    LoginComponent,
    ReportsComponent,
    ContactComponent,
    //CreditScoreCLAComponent,
    ToastMessage,
    ProfileComponent,
    SearchPipe,
    NotificationsComponent,
    OverviewModuleComponent,
    ParkiteReportComponent,
    CompanyViewComponent,
    ConfirmDailogComponent,
    ResetPasswordComponent,
    ProfileVerificationComponent,
    ProfileParkiteComponent,
    GstChargesComponent,
    // AddNewPlantTreesComponent,
    // PlantDetailsComponent,
    // ListOfPlantsTreesComponent,
    // PrintQrCodeComponent,
    DownloadQrComponent,
    RemoveModalComponent,
    GeneratePdfComponent,
    RemovemodalcouponComponent,
    AssigncouponComponent,
    RemovemodalcouponsurveyComponent,
    RemoveModalCustomerserviceUserComponent,
    RemoveModalGroupUserComponent,
    ChangeUserGroupComponent,
    ChangeUserGroupSingleComponent,
    SendSurveyReminderComponent,
    SurveyReminderSuccessComponent,
    RemovemodalvendorComponent,
    RemovemodalmenuComponent,
    ReviewremoveflagComponent,
    HidevendorreviewComponent,
    RemovemodalfoodcourtComponent,
    BookFacilityComponent,
    CancelFacilityBookingComponent,
    ViewBlockedFacilityComponent,
    AdalAuthComponent,
    ActiveParkConfirmationComponent,
    // EmergencyInfoComponent,
    RemovemodaluserroleComponent,
    AssignmodaluserroleComponent,
    ActiveEventCategoryModalComponent,
    ActiveEventModalComponent,
    DeactiveEventCategoryModalComponent,
    ApproveRejectPerticipantModalComponent,
    BookNewMeetingRoomComponent,
    CancelMeetingroomBooking,
    SecurityPasswordResendComponent,
    ViewBookingCompanyRoomComponent,
    ViewMeetingRoomBookingComponent,
    MeetingroomCancelPortalComponent,
  ],
  imports: [
    AngularSvgIconModule.forRoot(),
    NgbDropdownModule,
    NgxPaginationModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    SharedModule,
    HttpClientModule,
    NgHttpLoaderModule.forRoot(),
    MembersCLAModule,
    MembersRoutingModule,
    CompaniesCLAModule,
    CompaniesRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    CreditsCLAModule,
    CreditsRoutingModule,
    FaqModule,
    CompanyModule,
    ApprovalModule,
    AutosizeModule,
    LandscapingModule,
    WorkpermitModule,
    CouponsectionModule,
    SurveypollsModule,
    CustomerserviceModule,
    FoodcourtModule,
    NgSelectModule,
    AssignmembercardModule,
    NgbDatepickerModule,
    // EventsCLAModule,
    // EventsRoutingModule,
    //  MsAdalAngular6Module.forRoot({
    //   domain: environment.domain,
    //   tenant: environment.tenant,
    //   clientId: environment.clientId,
    //   redirectUri: environment.redirectUri,
    //   endpoints: {
    //     'https://localhost/Api/': 'xxx-bae6-4760-b434-xxx',
    //   },
    //   navigateToLoginRequestUrl: false,
    //   // cacheLocation: '<localStorage / sessionStorage>',
    //   cacheLocation: 'localStorage',
    //   postLogoutRedirectUri: environment.postLogoutRedirectUri,
    //   scopes: ['https://graph.microsoft.com/User.Read', 'openid', 'profile', 'User.Read'],
    // }),
    BrowserAnimationsModule,
    MsalModule,
    EmergencyinfoModule,
    RolepermissionModule,
    MeetingroomModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    DatePipe,
    // AuthenticationGuard,
    AppStateProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorProvider,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule { }
